module.exports = __webpack_public_path__ + "static/media/iar_vehicle_fire_selected.3a5b7771.svg";